import { useSankeyFormContext } from '../../contexts/sankeyFormContext';
import { useAppPlatform } from '../../utils/app';

export const useCopyFormInitialValues =
  (): WithExplicitFields<SankeyFormValues> => {
    const { form } = useSankeyFormContext();
    const createdWith = useAppPlatform();
    return {
      /* Copied values */
      background_color: form.getValues('background_color'),
      canvas_height: form.getValues('canvas_height'),
      canvas_size: form.getValues('canvas_size'),
      canvas_width: form.getValues('canvas_width'),
      chart: form.getValues('chart'),
      comparison_line_prefix: form.getValues('comparison_line_prefix'),
      comparison_line_suffix: form.getValues('comparison_line_suffix'),
      comparison_line_value_type: form.getValues('comparison_line_value_type'),
      custom_title: form.getValues('custom_title'),
      data_source_notes: form.getValues('data_source_notes'),
      download_image_format: form.getValues('download_image_format'),
      download_scale_png: form.getValues('download_scale_png'),
      fiscal_year: form.getValues('fiscal_year'),
      flows: form.getValues('flows'),
      font_family: form.getValues('font_family'),
      font_size: form.getValues('font_size'),
      label_pos: form.getValues('label_pos'),
      node_height: form.getValues('node_height'),
      node_spacing: form.getValues('node_spacing'),
      node_width: form.getValues('node_width'),
      nodes: form.getValues('nodes'),
      nr_of_decimals: form.getValues('nr_of_decimals'),
      owner_id: form.getValues('owner_id'),
      remembered_node_moves: form.getValues('remembered_node_moves'),
      reporting_period: form.getValues('reporting_period'),
      second_label_line_value_type: form.getValues(
        'second_label_line_value_type'
      ),
      show_canvas_resolution: form.getValues('show_canvas_resolution'),
      show_comparison_line: form.getValues('show_comparison_line'),
      show_data_editor: form.getValues('show_data_editor'),
      show_imbalances: form.getValues('show_imbalances'),
      show_labels: form.getValues('show_labels'),
      show_title: form.getValues('show_title'),
      show_watermark: form.getValues('show_watermark'),
      statement_type: form.getValues('statement_type'),
      svg_representation: form.getValues('svg_representation'),
      title_font_color: form.getValues('title_font_color'),
      title_font_size: form.getValues('title_font_size'),
      unit_prefix: form.getValues('unit_prefix'),
      unit_suffix: form.getValues('unit_suffix'),
      use_custom_title: form.getValues('use_custom_title'),
      /* Overrides */
      chart_type_list_position: undefined,
      chart_type_name: undefined,
      company_name: `${form.getValues('company_name').slice(0, 40)} (copy)`, // Truncate company name to 40 characters to satisfy DB constraint and append "(copy)" to it.
      created_at: undefined,
      created_with: createdWith,
      data_origin: 'inline', // Set copy's data origin to inline as we want to decouple its data from the original.
      id: 0,
      is_listed_chart_type_in_footer: false,
      is_main_example: false,
      is_official: false,
      is_template: false,
      points: undefined,
      public_permission: 'no-access',
      team_permission: 'no-access',
    };
  };
